import {load} from '@shopify/theme-sections';

import '../sections/hero-slider';
import '../sections/featured-products';
import '../sections/featured-collection';
import '../sections/featured-media';
import '../sections/featured-awards';
import '../sections/featured-carousel';
import '../sections/featured-expert-video';
import '../sections/image-banner';
import '../sections/image-columns';
import '../sections/images-row';
import '../sections/quotes-carousel';
import '../sections/before-after';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
